export const publicKey = `${process.env.REACT_APP_EMAILJS_PUBLIC_KEY}`;
export const serviceId = `${process.env.REACT_APP_SERVICE_ID}`;
export const templateId = `${process.env.REACT_APP_TEMPLATE_ID}`;